import { render, staticRenderFns } from "./NeedAssistantRequest.vue?vue&type=template&id=dac779ea"
import script from "./NeedAssistantRequest.vue?vue&type=script&lang=js"
export * from "./NeedAssistantRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports